import React from 'react';
import TestPlanDataTable from '../../components/table/TestPlanDataTable';
import DefaultLayout from '../../components/DefaultLayout';
import ObjectSummary from '../../components/summary/ObjectSummary';
import { t } from '../../i18n/t';
import PageComponent from '../../components/PageComponent';
import MContext from '../../models/MContext';
import TestExecutionHeaderContainer from './components/TestExecutionHeaderContainer';
import MFlags from '../../models/MFlags';
import ScheduleTestRunComponent from './components/ScheduleTestRunComponent';

class TestRunListPage extends PageComponent {

  constructor(props) {
    super(props);
    this.projectId = MContext.project.id;
    this.project = MContext.project;
    this.meta.id = 'page-test-run-list';
    this.meta.title = t('Project {{name}} - {{page}}', { name: this.project.name, page: t('test-execution#test-run-list') });
    this.renderHeader = this.renderHeader.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  renderToolbar() {
    return (
      <TestExecutionHeaderContainer {...this.props} headerTitle={t('test-execution#test-run-list')} />
    );
  }

  renderTestPlan() {
    const defaultSort = ['updatedAt,desc'];
    return (
      <TestPlanDataTable
        defaultSearchConditions={[]}
        defaultSort={defaultSort}
        tableId="testPlans"
        useSearchQuery
      />
    );
  }

  renderHeader() {
    const project = this.project;
    const urlParams = {
      testRunList: t('test-execution#test-run-list'),
      projectId: project.id,
      project: project.name,
    };
    return (
      <>
        <ScheduleTestRunComponent {...this.props} />
        <ObjectSummary params={urlParams} />
      </>
    );
  }

  renderBody() {
    return (
      <>
        {this.renderToolbar()}
        {this.renderTestPlan()}
      </>
    );
  }

  render() {
    const { projectId } = this;
    if (projectId) {
      return (
        <DefaultLayout
          renderHeader={null}
          renderBody={this.renderBody}
        />
      );
    }
    return null;
  }
}

export default TestRunListPage;
